import type { Sanctions } from '@/lib/apollo/query/get-applicant'
import { SanctionsStatus } from '@/lib/apollo/query/get-applicant'

export const isVerifiedStatus = (status?: SanctionsStatus): boolean =>
  status === undefined
    ? false
    : [SanctionsStatus.MATCH, SanctionsStatus.MISMATCH].includes(status)

export const showSanctionsBanner = (sanctions: Sanctions | null): boolean => {
  if (sanctions === null) {
    return false
  }

  switch (sanctions.status) {
    case SanctionsStatus.ACTION_REQUIRED:
      return true
    case SanctionsStatus.MATCH:
    case SanctionsStatus.MISMATCH:
    case SanctionsStatus.NOT_FOUND:
    default:
      return false
  }
}
